module.exports = __webpack_public_path__ + "img/online-community.4de82e43.png";